import React from "react";
import {HeroVideoCarousel} from "./HeroVideoCarousel";

const HeroSection = () => {
    return (<>
        <HeroVideoCarousel />
        <section id="home" className="page-section" style={{ background: "var(--branding-color-1)", color: "var(--branding-color-5)" }}>
            <h2 style={{ color: "var(--branding-color-5)" }}>
                Welcome to Ascension Counseling and Personal Development Services
            </h2>
            <p>
                Ascension Counseling and Personal Development Services (ACPD) is committed to providing quality mental health
                care, mental health education, and personal development support. We offer individual counseling and
                psychotherapy services to <b>individual adults</b> in the state of <b>Virginia</b>. Additionally, we proudly serve our local community by providing mental health education and advocacy through presentations, workshops, panel presentations, and webinars.
            </p>
        </section>
        </>
    );
};

export default HeroSection;
